import { Divider } from '../../../../../../Divider'
import { RentalPortalKeyFactsWidgetItem } from '../../../../../RentalPortalKeyFactsWidgetItem'
import { RentalPortalProvenanceChip } from '../../../../../RentalPortalProvenance'
import { getIsListingKeyFactsRentWarmRow } from '../RentalPortalListingProfileKeyFactsWidget.utils'

import * as styles from '../RentalPortalListingProfileKeyFactsWidget.module.css'

function RentalPortalListingProfileKeyFactsWidgetRow({
  label,
  ownership,
  rowKey,
  value,
}) {
  return (
    <>
      {getIsListingKeyFactsRentWarmRow(rowKey) ? (
        <Divider className={styles.divider} />
      ) : null}
      <RentalPortalKeyFactsWidgetItem
        label={label}
        labelEndContent={<RentalPortalProvenanceChip ownership={ownership} />}
        value={value}
      />
    </>
  )
}

export default RentalPortalListingProfileKeyFactsWidgetRow
